module.exports = __webpack_public_path__ + "img/macrosmos.e8dc53b0.svg";